import { useMemo } from 'react';

import { collection, query, where, orderBy, limit, CollectionReference, Query, QueryConstraint } from 'firebase/firestore';

import { useCollectionData } from 'react-firebase-hooks/firestore';

import { firestore } from '../firebase';
import UserAction from '../types/UserAction';

interface UseUserActionsProps {
  email?: string | null;
  maxResults?: number;
}

export default function useUserActions(props: UseUserActionsProps = {}) {
  const { email, maxResults = 50 } = props;

  const userActionQuery = useMemo(() => {
    const conditions: QueryConstraint[] = [];

    if (email) {
      conditions.push(where('email', '==', email.toLowerCase()));
    }

    conditions.push(orderBy('createTime', 'desc'));
    conditions.push(limit(maxResults));

    return query(
      collection(firestore, 'userAction') as CollectionReference<UserAction>,
      ...conditions
    ) as Query<UserAction>;
  }, [email, maxResults]);

  const [userActions, isUserActionsLoading, userActionsError] =
    useCollectionData<UserAction>(userActionQuery);

  return {
    userActions: userActions ?? [],
    isUserActionsLoading,
    userActionsError,
  };
}
